// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {Warehouse, deleteWarehouse} from './api'
import {KTIcon} from '../../../_metronic/helpers'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-hot-toast'
import {useState} from 'react'

const getWarehouseColumns = (
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>,
  setEditWarehouse: React.Dispatch<React.SetStateAction<Warehouse | undefined>>,
  setShouldRefreshWarehouses: React.Dispatch<React.SetStateAction<boolean>>
): ReadonlyArray<Column<Warehouse>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Warehouse Name'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'warehouse_name',
    accessor: 'warehouse_name',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Address' className='min-w-200px text-center' />
    ),
    id: 'address',
    accessor: 'street_address',
    sortType: 'alphanumeric',
    Cell: ({...props}) => {
      const w: Warehouse = props.data[props.row.index]
      return <div>{`${w.street_address}, ${w.city}, ${w.country}`}</div>
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Contact' className='min-w-200px text-center' />
    ),
    id: 'contact',
    accessor: 'contact_person',
    sortType: 'alphanumeric',
    Cell: ({...props}) => {
      const w: Warehouse = props.data[props.row.index]
      return (
        <div className='d-flex flex-column'>
          <span className='fw-bold'>{w.contact_person}</span>
          <span className='text-muted fs-7'>
            {w.email} | {w.phone_number}
          </span>
        </div>
      )
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Type' className='min-w-100px text-center' />
    ),
    accessor: 'warehouse_type',
    sortType: 'string',
    Cell: ({...props}) => {
      return (
        <span className='badge badge-light-primary fw-bold'>
          {props.data[props.row.index].warehouse_type}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-100px text-center' />
    ),
    accessor: 'status',
    sortType: 'string',
    Cell: ({...props}) => {
      const status = props.data[props.row.index].status
      return (
        <span
          className={`badge fw-bold ${
            status === 'active' ? 'badge-light-success' : 'badge-light-danger'
          }`}
        >
          {status.toUpperCase()}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='min-w-100px text-center' />
    ),
    accessor: 'actions',
    sortable: false,
    Cell: ({...props}) => {
      const [showDeleteModal, setShowDeleteModal] = useState(false)

      const handleDelete = async () => {
        deleteWarehouse(props.data[props.row.index].warehouse_id)
          .then((res) => res?.detail && toast.success(res.detail))
          .catch((err) => err && toast.error(err))
          .finally(() => {
            setShouldRefreshWarehouses(true)
            setShowDeleteModal(false)
          })
      }

      const handleEdit = () => {
        setShowForm(true)
        setEditWarehouse(props.data[props.row.index])
      }

      return (
        <>
          <div className='d-flex justify-content-center flex-shrink-0'>
            <div
              onClick={handleEdit}
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Edit'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </div>
            <div
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Mark Inactive'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => setShowDeleteModal(true)}
            >
              <KTIcon iconName='trash' className='fs-3' />
            </div>
          </div>

          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            id='delete_warehouse'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={showDeleteModal}
            animation={false}
          >
            <div className='modal-content'>
              {/*begin::Header*/}
              <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fw-bold m-0'>Mark Warehouse Inactive</h5>
                <div className='d-flex ms-2'>
                  {/*begin::Close*/}
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                  {/*end::Close*/}
                </div>
              </div>
              {/*end::Header*/}
              <div className='text-center py-5 px-5'>
                This warehouse will be marked inactive and removed from new inventory
                transactions. Historical records will be preserved.
              </div>
              <div className='text-center pt-5 pb-5'>
                <button
                  type='reset'
                  onClick={() => setShowDeleteModal(false)}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  onClick={handleDelete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
        </>
      )
    },
  },
]

export {getWarehouseColumns}
